import { sha256 } from 'js-sha256';
import { type Query } from 'react-resource-router';

type QueryAnalytics = {
	queryHash: string;
	queryLength: number;
	referrer: string;
};

export const generateQueryMetrics = (
	urlQueryParams: Query,
	text?: string | undefined,
): QueryAnalytics => {
	return {
		queryHash: sha256(text || ''),
		queryLength: text?.length || 0,
		referrer: urlQueryParams.referrer,
	};
};
